module.exports = __webpack_public_path__ + "img/canal-do-anuncio.af2fb6a4.svg";